import "./AiSummarySkeleton.scss";

const AiSummarySkeleton = () => {
	return (
		<div className="ai-summary ai-summary--skeleton" aria-hidden="true">
			{/* Header */}
			<div className="ai-summary__header">
				<div className="skeleton sk-header" />
			</div>

			{/* Body */}
			<div className="ai-summary__body">
				{/* Icon placeholder */}
				<div className="ai-summary__icon sk-icon skeleton" />

				{/* Content placeholder */}
				<div className="ai-summary__content">
					<div className="skeleton sk-title" />

					<div className="skeleton sk-line" />
					<div className="skeleton sk-line" />
					<div className="skeleton sk-line sk-line--short" />

					{/* Show more button placeholder */}
					<div className="skeleton sk-button" />
				</div>
			</div>
		</div>
	);
};

export default AiSummarySkeleton;